
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","viewBox":"0 0 17 17"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"i-stroke",attrs:{"stroke":"#798f8f","stroke-linecap":"round","stroke-linejoin":"round","d":"M12.357 6.786H14.5V5.598m0-1.91V2.5h-2.143m-2.571 0H7.214m-2.571 0H2.5v1.188m0 1.91v1.188h2.143m0 3.428H2.5V14.5h12v-4.286h-2.357m-5.357 0L8.5 12m0 0 1.714-1.786M8.5 12V6.5"}})])
          )
        }
      }
    